import styled from 'styled-components';

export const CameraPageWrapper = styled.div`
display: flex;
`;
